module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_c('span', [_vm._v("©")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.email
    }
  }, [_vm._v("Veronica Solomon")]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(_vm.year))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1698beb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot.vue
// module id = 111
// module chunks = 0